import { ledgersRestrictedFromCSVUpload } from 'constants/bulkActions';
export const isCSVUploadAllowed = (ledgerApplication) => !ledgersRestrictedFromCSVUpload.includes(ledgerApplication);
